import React, { useCallback, useEffect, useState } from 'react';
import { History, Loader2, RefreshCcw } from 'lucide-react';
import api from '@/lib/axios';

const ORIGENS = [['', 'Todas as origens'], ['moderacao', 'Moderação'], ['precos', 'Preços'], ['divulgacao', 'Divulgação']];

export default function MarketplaceAuditPanel() {
  const [origem, setOrigem] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const res = await api.get(`/admin/marketplace/auditoria?${origem ? `origem=${origem}&` : ''}limit=80`);
      setItems(res.data.items || []);
    } catch (e) { setErr(e.response?.data?.detail || 'Falha a carregar a auditoria.'); }
    finally { setLoading(false); }
  }, [origem]);

  useEffect(() => { load(); }, [load]);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="admin-audit-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="inline-flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg">
          <History className="h-4 w-4 text-emerald-600" /> Auditoria
        </h2>
        <div className="flex items-center gap-2">
          <select value={origem} onChange={(e) => setOrigem(e.target.value)}
            className="rounded-lg border border-slate-300 px-2 py-1.5 text-xs" data-testid="admin-audit-filter">
            {ORIGENS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <button type="button" onClick={load} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-600" data-testid="admin-audit-reload">
            <RefreshCcw className="h-3.5 w-3.5" /> Atualizar
          </button>
        </div>
      </div>

      {err && <p className="mt-2 text-xs font-semibold text-red-600" data-testid="admin-audit-error">{err}</p>}
      {loading ? (
        <p className="mt-4 flex items-center gap-2 text-xs text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> A carregar...</p>
      ) : items.length === 0 ? (
        <p className="mt-4 text-xs text-slate-500" data-testid="admin-audit-empty">Sem registos de auditoria.</p>
      ) : (
        <ol className="mt-3 space-y-1.5" data-testid="admin-audit-list">
          {items.map((it, i) => (
            <li key={`${it.em}-${i}`} className="rounded-xl border border-slate-200 bg-slate-50 p-2.5 text-[11px]">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <span className="font-semibold text-slate-800">[{it.origem}] {it.acao}</span>
                <span className="text-slate-500">{it.em ? new Date(it.em).toLocaleString('pt-PT') : '—'}</span>
              </div>
              <p className="text-slate-500">Alvo: {it.alvo || '—'} · Por: {it.por || '—'}</p>
              {it.motivo && <p className="text-slate-600">Motivo: {it.motivo}</p>}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
